import { p as public_env } from "../../../../chunks/shared-server.js";
const load = async ({ params, url }) => {
  let page = url.searchParams.get("page");
  if (!page) page = 0;
  const count = 20;
  const INDEXER_BASE_URL = public_env.PUBLIC_INDEXER_BASE_URL;
  const apiUrl = `${INDEXER_BASE_URL}/governance/dreps/deregistrations?page=${page}&count=${count}`;
  console.log(apiUrl);
  const res = await fetch(apiUrl);
  const data = await res.json();
  const deregistrations = data;
  console.log(data);
  if (res.ok) {
    return {
      deregistrations,
      total: 0,
      total_pages: 0,
      page,
      count
    };
  }
  return {
    status: 404,
    body: { error: "Can not fetch drep deregistrations." }
  };
};
export {
  load
};
